import axios from "@/axios.js"

export default {
  fetchCompetitions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/competition/getall")
        .then((response) => {
          commit('SET_COMPETITIONS_FULL', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCompetitionsPartial({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/competition/getpartial`)
        .then((response) => {
          commit('SET_COMPETITIONS_PARTIAL', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCompetitionByLink({ commit }, link) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/competition/getbylink/${link}`)
        .then((response) => {
          commit('SET_COMPETITION_CURRENT', response.data.data);
          resolve(response);
        })
        .catch((error) => { reject(error) });
    });
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  setActiveStatus({ dispatch }, link) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/competition/setactivestatus/${link}`)
        .then((response) => {
          dispatch('competition/SET_COMPETITIONS_FULL');
          dispatch('competition/SET_COMPETITIONS_PARTIAL');
          resolve(response);
        })
        .catch((error) => { reject(error) });
    });
  },
  setFeaturedStatus({ dispatch }, link) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/competition/setfeaturedstatus/${link}`)
        .then((response) => {
          dispatch('competition/SET_COMPETITIONS_FULL');
          dispatch('competition/SET_COMPETITIONS_PARTIAL');
          resolve(response);
        })
        .catch((error) => { reject(error) });
    });
  }
}
